/* eslint-disable global-require */
const dynamicWatchers = {};

// `require` in every file except index.js from the current directory, then
// add their default export to module.exports based on their filename.
// eg dynamicMiddlewares["dynamicMiddleware"] = require("./dynamicMiddleware.js");
const req = require.context('.', true, /\.saga\.js$/);
req.keys().forEach(fileName => {
  const exportName = fileName.replace('./', '').replace('.saga.js', '');
  dynamicWatchers[exportName] = req(fileName).default;
});

export { dynamicWatchers };
